// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RUxW","colMin":"styles_colMin__1tmoU"};